<template>
    <ul class="navi-group">
        <li class="navi-item nav-heading rounded">Mein Konto</li>
        <li class="nav-item" @click="toggleMenu"><router-link :to="{name: 'konto-adresse'}"    class="nav-link" exact>Meine Adresse</router-link></li>
        <li v-if="user && user.user_type == 'gewerblich'" class="nav-item" @click="toggleMenu"><router-link :to="{name: 'konto-impressum'}"    class="nav-link" exact>Mein Impressum </router-link></li>
        <li class="nav-item" @click="toggleMenu"><router-link :to="{name: 'konto-zugang'}"     class="nav-link" exact>Anmeldung und Sicherheit</router-link></li>
        <li class="nav-item" @click="toggleMenu"><router-link :to="{name: 'konto-vertraege'}"  class="nav-link" exact>Meine Verträge</router-link></li>
        <li class="nav-item" @click="toggleMenu"><router-link :to="{name: 'konto-rechnungen'}" class="nav-link" exact>Meine Rechnungen</router-link></li>
        <li v-if="user && user.payment_method != 'ueberweisung' && user.packet && sepaInfoMissing && opened_invoices.length > 0" class="nav-item" @click="toggleMenu">
            <router-link :to="{name: 'invoice-payment', params: {invoice_id: opened_invoices[0].id}}" class="nav-link" exact>Meine Zahlungsdaten</router-link>
        </li>
        <li v-if="user && user.payment_method != 'ueberweisung' && user.packet && !sepaInfoMissing" class="nav-item" @click="toggleMenu">
            <router-link :to="{name: 'konto-zahlungsdaten'}" class="nav-link" exact>Meine Zahlungsdaten</router-link>
        </li>
    </ul>
</template>

<script>
    import { ToggleMenuMixin } from '../../../mixins/ToggleMenu';

    export default {
      data(){
        return {
          user: this.$store.state.user,
          sepaInfoMissing : this.$store.state.sepaInfoMissing,
          opened_invoices : []
        }
      },
      beforeCreate() {

        this.$store.watch(() => {
            return this.$store.getters.sepaInfoMissing;
        }, sepaInfoMissing => {
            this.sepaInfoMissing = sepaInfoMissing;
        });

        this.$store.watch(() => {
            return this.$store.getters.user;
        }, user => {
            this.user = user;
        });

        this.$http.get('invoiceApi/getOpenedInvoice').then(response => {
          this.opened_invoices = JSON.parse(response.data);
        }).catch(error => {
          console.log(error);
        });
      },
      created() {



      },
      mixins: [ToggleMenuMixin]
    }
</script>

<style scoped>

</style>
